"use client";

import type * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Skeleton — the Calm Authority loading placeholder (BillingSkeleton pattern):
 * a pulsing block on `--surface-3`. Compose layout-shaped blocks inside bordered
 * cards instead of a lone centered spinner when the final layout is known.
 */
export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return (
    <div
      className={cn("animate-pulse rounded bg-[var(--surface-3)]", className)}
      data-slot="skeleton"
      {...props}
    />
  );
}
